import React, { useState, useEffect, useCallback } from 'react';
import { X, Star } from 'lucide-react';

const REVIEWS = [
  { name: 'James T.', location: 'Augusta, GA', text: 'Saved $340/year on my home & auto bundle!', stars: 5 },
  { name: 'Maria S.', location: 'North Augusta, SC', text: 'Best insurance experience in 20 years.', stars: 5 },
  { name: 'Robert K.', location: 'Evans, GA', text: 'They found coverage my old agent missed entirely.', stars: 5 },
  { name: 'Linda P.', location: 'Aiken, SC', text: 'Quick, professional, and truly personalized service.', stars: 5 },
  { name: 'David M.', location: 'Martinez, GA', text: 'Switched from Geico — saved $28/month instantly.', stars: 5 },
  { name: 'Susan W.', location: 'Columbia, SC', text: 'Veteran-owned and it shows. Real integrity.', stars: 5 },
];

const SocialProof = () => {
  const [current, setCurrent] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [reviewIndex, setReviewIndex] = useState(0);

  const showNext = useCallback(() => {
    if (dismissed) return;
    setCurrent(REVIEWS[reviewIndex % REVIEWS.length]);
    setReviewIndex((prev) => prev + 1);

    setTimeout(() => setCurrent(null), 6000);
  }, [dismissed, reviewIndex]);

  useEffect(() => {
    const initialDelay = setTimeout(() => {
      showNext();
    }, 8000);

    return () => clearTimeout(initialDelay);
  }, []);

  useEffect(() => {
    if (reviewIndex === 0 || dismissed) return;
    const interval = setTimeout(showNext, 15000);
    return () => clearTimeout(interval);
  }, [reviewIndex, dismissed, showNext]);

  if (!current || dismissed) return null;

  return (
    <div
      className="fixed bottom-16 sm:bottom-6 left-3 sm:left-6 z-[55] w-[calc(100%-4.5rem)] sm:w-auto sm:max-w-xs animate-in slide-in-from-left-5 fade-in duration-500"
      data-testid="social-proof-notification"
    >
      <div className="bg-white rounded-xl shadow-2xl border border-gray-100 p-3 sm:p-4 relative">
        <button
          onClick={() => { setCurrent(null); setDismissed(true); }}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
          data-testid="social-proof-close"
          aria-label="Dismiss"
        >
          <X size={14} />
        </button>
        <div className="flex gap-2.5 sm:gap-3 items-start pr-4">
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#101C47] flex items-center justify-center text-white font-bold text-xs sm:text-sm flex-shrink-0">
            {current.name.charAt(0)}
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-0.5 mb-0.5">
              {Array.from({ length: current.stars }).map((_, i) => (
                <Star key={i} size={10} className="text-yellow-400 fill-yellow-400 sm:w-3 sm:h-3" />
              ))}
            </div>
            <p className="text-xs sm:text-sm text-gray-800 font-medium leading-snug">"{current.text}"</p>
            <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5">
              {current.name} — {current.location}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialProof;
